import GlpFileLink from './GlpFileLink.vue'

export { GlpFileLink }
